
import axios from 'axios'

class Loqate {
  key;
  constructor(key) {
    this.key = key;
    this.countries = [
      'AT',
      'BE',
      'BG',
      'HR',
      'CY',
      'CZ',
      'DK',
      'EE',
      'FI',
      'FR',
      'DE',
      'GR',
      'HU',
      'IE',
      'IT',
      'LV',
      'LT',
      'LU',
      'MT',
      'NL',
      'PO',
      'PT',
      'RO',
      'SK',
      'SI',
      'ES',
      'SE',
      'AL',
      'AD',
      'AM',
      'BY',
      'BA',
      'FO',
      'GE',
      'GI',
      'IS',
      'IM',
      'XK',
      'LI',
      'MK',
      'MD',
      'MC',
      'ME',
      'NO',
      'RU',
      'SM',
      'RS',
      'CH',
      'TR',
      'UA',
      'GB',
      'VA',
      'GBR'
    ];
  }

  find(search, opts = {}) {
    const defaultOpts = {
      method: 'get',
      url: 'https://api.addressy.com/Capture/Interactive/Find/v1.1/json3.ws',
      timeout: 1000,
      headers: {},
      params: {
        Key: this.key,
        Text: search,
        IsMiddleware: true,
        Origin: 'GB',
        Countries: {codesList: this.countries.join(',')},
        Limit: 50,
        Language: 'en-gb'
      }
    };

    return axios({
      ...defaultOpts,
      ...opts,
    })
  }

  address(search, opts = {}) {
    const defaultOpts = {
      method: 'get',
      url: 'https://api.addressy.com/Capture/Interactive/Retrieve/v1/json3.ws',
      timeout: 1000,
      headers: {},
      params: {
        Key: this.key,
        Id: search
      }
    };

    return axios({
      ...defaultOpts,
      ...opts,
    })
  }

  container(search, opts = {}) {
    const defaultOpts = {
      method: 'get',
      url: 'https://api.addressy.com/Capture/Interactive/Find/v1.1/json3.ws',
      timeout: 1000,
      headers: {},
      params: {
        Key: this.key,
        IsMiddleware: true,
        Container: search,
        Countries: {codesList: this.countries.join(',')},
        Origin: 'GB',
        Limit: 50,
        Language: 'en-gb'
      }
    };

    return axios({
      ...defaultOpts,
      ...opts,
    })
  }
}

export default Loqate;
